export default __webpack_public_path__ + "static/media/ios_share.a7808b29.svg";